import { createAsyncThunk } from '@reduxjs/toolkit';
import { createRequirement, createRequirementMessage, getRequirement, getRequirements, getRequirementsAll, updateRequirement, uploadRequirementMessageFile } from '../api/requirementsApi';
import { showAlert } from '../slices/alertsSlice';
import { setCurrentRequirement, setRequirementsList } from '../slices/requirementsSlice';
import { handleError } from '../slices/errorsSlice';
import { startLoading, endLoading } from '../slices/loadingSlice';

export const getRequirementsListAll = createAsyncThunk('requirements/getRequirementsList', ({ query }, { getState, dispatch }) => {
  const { token } = getState().auth;

  dispatch(startLoading());

  getRequirementsAll(token, query)
    .then(response => response.status === 200 ? response.json() : Promise.reject(response))
    .then(data => dispatch(setRequirementsList({ requirements: data.requirements })))
    .catch(err => dispatch(handleError(err)))
    .finally(() => dispatch(endLoading()));
});

export const getRequirementsList = createAsyncThunk('requirements/all', ({ query }, { getState, dispatch }) => {
  const { token } = getState().auth;

  dispatch(startLoading());

  getRequirements(token, query)
    .then(response => response.status === 200 ? response.json() : Promise.reject(response))
    .then(data => dispatch(setRequirementsList({ requirements: data.requirements })))
    .catch(err => dispatch(handleError(err)))
    .finally(() => dispatch(endLoading()));
});

export const getCurrentRequirement = createAsyncThunk('requirements/getCurrentRequirement', ({ id, callback }, { getState, dispatch }) => {
  const { token } = getState().auth;

  dispatch(startLoading());

  getRequirement(token, id)
    .then(response => response.status === 200 ? response.json() : Promise.reject(response))
    .then(data => dispatch(setCurrentRequirement({ requirement: data.requirement })))
    .then(() => callback?.())
    .catch(err => dispatch(handleError(err)))
    .finally(() => dispatch(endLoading()));
});

export const createNewRequirement = createAsyncThunk('requirements/createNewRequirement',async ({ requirement, callback }, { getState, dispatch }) => {
    const { token } = getState().auth;

    dispatch(startLoading());

    try {
      
      const response = await createRequirement(token, requirement);

      if (response.status !== 200) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Error al crear requerimiento');
      }

      const data = await response.json();
      return data.requirement;
    } catch (err) {
      dispatch(handleError(err));
      return Promise.reject(err);
    } finally {
      dispatch(endLoading());
    }
  }
);

export const updateCurrentRequirement = createAsyncThunk('requirements/updateCurrentRequirement', ({ id, requirement }, { getState, dispatch }) => {
  const { token } = getState().auth;

  dispatch(startLoading()); 

  updateRequirement(token, id, requirement)
    .then(response => response.status === 200 ? response.json() : Promise.reject(response))
    .then(data => dispatch(setCurrentRequirement({ requirement: data.requirement })))
    .then(() => dispatch(showAlert({ message: 'Requirement actualizado', type: 'success' })))
    .catch(err => dispatch(handleError(err)))
    .finally(() => dispatch(endLoading()));
});

export const createNewRequirementMessage = createAsyncThunk('requirements/createNewRequirementMessage', ({ id, message, callback }, { getState, dispatch }) => {
  const { token } = getState().auth;

  dispatch(startLoading());

  createRequirementMessage(token, id, { message })
    .then(response => response.status === 201 ? response.json() : Promise.reject(response))
    .then(data => callback(data.requirement))
    .catch(err => dispatch(handleError(err)))
    .finally(() => dispatch(endLoading()));
});

export const uploadNewRequirementMessageFile = createAsyncThunk('requirements/uploadNewRequirementMessageFile', ({ id, file, callback }, { getState, dispatch }) => {
  const { token } = getState().auth;

  dispatch(startLoading());

  uploadRequirementMessageFile(token, id, file)
    .then(response => response.status === 201 ? response.json() : Promise.reject(response))
    .then(() => dispatch(showAlert({ message: 'Archivo cargado correctamente', type: 'success' })))
    .then(() => callback())
    .catch(err => dispatch(handleError(err)))
    .finally(() => dispatch(endLoading()));
});
